<ng-container *transloco="let t">
  <div class="pt-62-32 pb-300-100">
    <div class="row">
      <div [ngClass]="{'col-12': true, 'col-xxl-8': isEventItem(currentItem), 'pr-xxl-4': isEventItem(currentItem)}">
        <app-entry-list-item>
          <div class="d-flex flex-xxl-row flex-column">
            <div class="d-flex flex-row flex-xxl-column">

              <div class="pt-20-0 fw-bold fs-18" *ngIf="isEventItem(currentItem)">
                {{ currentItem?.organiser?.fullName ?? "" }}
              </div>
            </div>
            <div class="fs-18-16">
              <div class="pt-20-0 fw-bold fs-18" *ngIf="!isEventItem(currentItem)">
                {{ currentItem?.organiser?.fullName ?? "" }}
              </div>


              <div class="pt-30-28 social-networks" *ngIf="isEventItem(currentItem)">
                <img src="assets/img/svg/facebook.svg" alt="Facebook">
                <img src="assets/img/svg/X.svg" alt="X">
                <img src="assets/img/svg/instagram.svg" alt="Instagram">
                <img src="assets/img/svg/youtube.svg" alt="Youtube">
              </div>
            </div>
          </div>
        </app-entry-list-item>
      </div>
      <ng-container *ngIf="isEventItem(currentItem)">
        <div class="col-12 col-xxl-4">
          <app-section-subtitle [subtitle]="t('events.details.contacts')"/>
          <app-entry-list-item>
            <div class="contact-grid">
              <div class="label">{{ t('events.details.contacts.info.email') }}</div>
              <div class="info cursor-pointer" (click)="openContactOrganiserModal()">
                {{ currentItem?.organiser?.email ?? "" }}
              </div>

              <div class="label">{{ t('events.details.contacts.results.email') }}</div>
              <div class="info">
                <a href="mailto:rezultati@stotinka.hr">
                  {{ "rezultati@stotinka.hr" }}
                </a>
              </div>

              <div class="label">{{ t('events.details.contacts.applications.phone') }}</div>
              <div class="info"><a href="tel:{{currentItem?.organiser?.phone ?? ''}}">{{
                  currentItem?.organiser?.phone
                  ?? ""
                }}</a>
              </div>

              <div class="label">{{ t('events.details.contacts.results.phone') }}</div>
              <div class="info"><a href="tel:{{currentItem?.organiser?.phone ?? ''}}">{{
                  currentItem?.organiser?.phone
                  ?? ""
                }}</a>
              </div>
              <div class="label">{{ t('app.landing.other') }}:</div>
              <div class="page">
                @for (phoneNumber of currentItem?.phoneNumbers;track phoneNumber) {
                  <div class="column">
                    <div class="item">
                      <app-language-output style="font-size: 15px;" [hrLabel]="phoneNumber.name"
                                           [enLabel]="phoneNumber.nameEng"
                                           [srLabel]="phoneNumber.nameSr"
                                           [bsLabel]="phoneNumber.nameBs"
                                           [itLabel]="phoneNumber.nameIta" [siLabel]="phoneNumber.nameSlo"
                                           [defaultLanguage]="currentItem?.defaultLanguage"
                                           [defaultLabel]="t('event.awardFund.details.empty')" [languages]="languages"/>
                      <div class="info"><a href="tel:{{phoneNumber.phone ?? ''}}">{{
                          phoneNumber.phone
                          ?? ""
                        }}</a>
                      </div>
                    </div>
                  </div>
                }
              </div>
            </div>
          </app-entry-list-item>
        </div>
      </ng-container>
    </div>
  </div>
</ng-container>
